module.exports = new __parcel__URL__("ej--discovery-cover.2ebfad88.jpeg").toString();